import {useEventListener} from '../../../hooks/useEventListener';

export const useFontsLoadedListener = (listener: (event: Event) => any) => {
  useEventListener(document.fonts, 'loadingdone', listener);
};
